import React, { useState } from "react" ;
import { Accordion, Card, Tooltip, OverlayTrigger } from "react-bootstrap";

import { Globals } from "root/DataFunctions/BaseDataFns";
import { getDocumentUrl } from "root/DataFunctions/CommonDataFns";
import {IconPath} from "root/DataFunctions/Constants";

const MemberAccordion = ({ member }) => {
    const [expandAccordion, setExpandAccordion] = useState(false);

    const imageUrl = getDocumentUrl(member.enc_user_image_id, 200, true);
    
    const getDocUrl = (  ) =>
    {
        let url = '/getFile.php?enc_docid=' + member.document_id;
        return url;
    }
    // const imageUrl = 'getFile.php/?enc_docid=' + member.image_id;
    
    const rightArrowHeadUrl = Globals.BaseURL + "/images/icons/child/right-arrow-head.svg";
    const externalLinkUrl = Globals.BaseURL + "/images/icons/child/external-link.png";
    const pdfIconUrl = Globals.BaseURL + IconPath.ICON_PDF;

    return (
        <div className="tree-member">
            <Accordion>
                <Accordion.Toggle
                    className="tree-member-name" 
                    onClick={()=>setExpandAccordion(!expandAccordion)}
                    as={Card.Header} 
                    eventKey="0"
                >
                    <div className="member-dp">
                        <img className="member-dp-img" src={imageUrl} alt={member.firstname} />
                        <div className="member-dp-more child_icon">
                            <img className="member-dp-more-icon child_icon_pic" src={externalLinkUrl} alt="external link" />
                        </div>
                    </div>
                    <div className="member-details-wrap">
                        <div className="member-details">
                            <p className="member-details-name">{member.firstname} {member.surname}</p>
                            <p className="member-details-relationship">{member.name}</p>
                        </div>
                        <div className="member-details-expand" >
                            <img 
                                className={`member-details-expand-icon ${expandAccordion ? 'expanded' : ''}`}
                                src={rightArrowHeadUrl} 
                                alt="Expand arrow" 
                            />
                        </div>
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse className="tree-member-body" eventKey="0">
                    <Card.Body className="tree-member-body-summary">
                        {member.summary}
                        
                        {member.document_id && <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-right">
                                    More Information
                                </Tooltip>
                            }
                        >
                            <a href={getDocUrl()} target="_blank"> 
                                <span className="member-more">
                                    <img src={pdfIconUrl} style={{height: '50px'}}alt="pdf link" />
                                </span>
                            </a>
                        </OverlayTrigger>}

                    </Card.Body>
                </Accordion.Collapse>
            </Accordion>
        </div>
    );
}

export default MemberAccordion;
